import { render, staticRenderFns } from "./HealthInfoFormTab.vue?vue&type=template&id=81bafab4"
import script from "./HealthInfoFormTab.vue?vue&type=script&lang=js"
export * from "./HealthInfoFormTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports